<script setup lang="ts">
import {computed, PropType, Ref, ref, watch} from 'vue'
import {IonButton, IonIcon, IonLabel, IonTextarea, TextareaCustomEvent} from '@ionic/vue'
import {
    absencePlanningAbsenceTypes,
    cmpAbsenceTypes,
    defaultAbsenceType,
    getAbsenceTypes,
    getIconForAbsenceType,
    getLabelForAbsenceType, sicknessAbsenceTypes
} from '@/helper/absence'
import RadioGroup from '@/components/RadioGroup.vue'
import {Absence, AbsenceType} from '@/graphql/generated/graphql';
import dateHelper, {isWeekend} from "@/helper/datetime/date";
import {kapitelDateString} from "@/graphql/kapitelTypes";

const props = defineProps({
    date: {
        type: String as PropType<kapitelDateString>,
        required: true
    },
    absence: {
        type: Object as PropType<Absence>,
        required: true
    }
})

const emit = defineEmits(["update:absence"]);

const localType = ref(defaultAbsenceType)
watch(() => props.absence?.type,()=> {if (props.absence?.type) {localType.value = props.absence?.type}}, {immediate: true})

const localComment : Ref<string|undefined> = ref("")
watch(() => props.absence?.comment,()=> localComment.value = props.absence?.comment ?? undefined, {immediate: true})


const changedProps = {
    comment: undefined as string | undefined,
    type: undefined as AbsenceType | undefined,
};
const onChangeType =(type: AbsenceType)=> {
    localType.value = type;
    changedProps.type = type
    saveAbsence()
}
const onChangeComment =({target} : TextareaCustomEvent)=> {
    localComment.value = target.value ?? undefined;
    changedProps.comment = target.value ?? undefined
    saveAbsence()
}
const onDeleteSickness = () => {
    localType.value = defaultAbsenceType
    changedProps.type = defaultAbsenceType
    saveAbsence()
}
const saveAbsence = async () => {
    const absence = props.absence

    if(changedProps.type){
        absence.type=changedProps.type
    }

    if(changedProps.comment!==undefined){
        absence.comment = changedProps.comment
    }

    emit("update:absence", absence)
    console.log("update:absence", absence)
}

const isSelectableAbsenceType =  (type: AbsenceType) => !sicknessAbsenceTypes.includes(type) && !((isWeekend(props.date) /* TODO: || isHoliday */) && absencePlanningAbsenceTypes.includes(type))
const selectableAbsenceTypes : Ref<AbsenceType[]> = computed(_ => getAbsenceTypes().filter(isSelectableAbsenceType).toSorted(cmpAbsenceTypes))




</script>

<template>

    <template v-if="isSelectableAbsenceType(localType) || !localType">
        <RadioGroup
            :items="selectableAbsenceTypes"
            :model-value="localType"
            v-slot="{item}"
            v-on:update:modelValue="onChangeType"
        >
            {{ getLabelForAbsenceType(item) }}
        </RadioGroup>

        <ion-textarea
            v-if="localType"
            label="Kommentar"
            label-placement="stacked"
            :value="localComment"
            @ionChange="onChangeComment"
        />
    </template>
    <template v-else-if="localType && !isSelectableAbsenceType(localType)">
        <p>
            <IonLabel>
                Du bist aktuell für den {{ dateHelper.formatKapitelDate(date) }} krank gemeldet. Möchtest du die Krankmeldung zurückziehen?
            </IonLabel>
        </p>
        <IonButton color="light" @click="onDeleteSickness"><IonIcon :icon="getIconForAbsenceType(AbsenceType.Sickness)" style="margin-right: 0.5em"/>Krankmeldung löschen</IonButton>
    </template>

</template>

<style scoped>
ion-list {
    background-color: var(--ion-color-light);
    border-radius: 1rem;

    ion-item {
        padding-left: 1em;
    }

    ion-icon {
        margin-right: 0.5em;
    }

    margin-bottom: 1rem;
}
</style>
